<div class="main-content">

  <!-- ===== HEADER ===== -->
  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--green">
        <i class="fas fa-undo-alt"></i>
      </div>
      <div>
        <h1 class="main-title">Richiesta di Reso</h1>
        <p class="main-subtitle">Interfaccia di gestione delle richieste di reso dedicata alle utenze Dealer</p>
      </div>
    </div>

    <!-- Tour Guide Button + Settings (admin only) -->
    <div class="tour-guide-button-container d-flex align-items-center gap-2">
      <button *ngIf="isAdmin()"
                type="button"
                class="btn btn-outline-primary"
              (click)="openReturnSettingsPopup()"
              title="Gestione tipi di reso">
        <i class="fas fa-cog me-1"></i>
        Impostazioni resi
      </button>

      <!-- Senza dealer configurati le sezioni non esistono: la guida non ha nulla da mostrare -->
      <button *ngIf="hasDealerCodes"
        type="button" class="btn tour-guide-btn" (click)="startTour()"
        [title]="'TOUR.START_TOUR' | translate">
        <div class="tour-btn-content">
          <div class="tour-btn-icon">
            <i class="fas fa-route"></i>
            <div class="tour-btn-pulse"></div>
          </div>
          <div class="tour-btn-text">
            <span class="tour-btn-title">{{ 'TOUR.START_TOUR' | translate }}</span>
            <small class="tour-btn-subtitle">{{ 'TOUR.LEARN_MANAGEMENT' | translate }}</small>
          </div>
        </div>
      </button>
    </div>
  </div>

  <!-- ===== SECTION 1: USER & COMPANIES (disattivata) =====
  <div id="user-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-user header-icon"></i>
          <h3>Utente e Aziende collegate</h3>
        </div>

        Utenza e mail: evidenziate al centro dell'header della sezione
        <div class="user-chip" *ngIf="user">
          <i class="fas fa-user-circle"></i>
          <span class="user-chip-name">{{ user.userName }}</span>
          <span class="user-chip-separator"></span>
          <i class="fas fa-envelope"></i>
          <span class="user-chip-email">{{ user.userEmail }}</span>
        </div>

        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="toggleUserSectionCollapse()"
                [title]="isUserSectionCollapsed ? 'Espandi' : 'Comprimi'">
          <i class="fas" [ngClass]="isUserSectionCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </div>
    <div class="card-body" *ngIf="!isUserSectionCollapsed">
      <h5 class="section-subtitle">
        <i class="fas fa-building me-2"></i>
        Aziende rappresentate ({{ companies.length }})
      </h5>

      <div id="company-cards" class="row g-2">
        <div class="col-6 col-md-4 col-lg-3" *ngFor="let company of companies">
          <div class="company-card"
               [class.selected]="selectedCompanyCode === company.code"
               [class.locked]="isSingleCompany()"
               (click)="selectCompany(company.code)">
            <div class="company-card-header">
              <i class="fas fa-industry"></i>
              <div class="company-card-info">
                <strong>{{ company.name }}</strong>
                <span class="company-card-code">{{ company.code }}</span>
              </div>
              <i class="fas fa-check-circle company-card-check"
                 *ngIf="selectedCompanyCode === company.code"
                 [title]="isSingleCompany() ? 'Unica azienda: selezione obbligatoria' : 'Selezionata per il reso'"></i>
              <button type="button" class="company-card-toggle"
                      (click)="toggleCompanyDetails(company.code, $event)"
                      [title]="isCompanyExpanded(company.code) ? 'Nascondi dettagli' : 'Mostra dettagli'">
                <i class="fas" [ngClass]="isCompanyExpanded(company.code) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </button>
            </div>
            <div class="company-card-details" *ngIf="isCompanyExpanded(company.code)">
              <div><span class="label">P. IVA:</span> {{ company.vatNumber || '-' }}</div>
              <div><span class="label">Indirizzo:</span> {{ company.address || '-' }}</div>
              <div><span class="label">Città:</span> {{ company.city || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  ===== FINE SECTION 1 ===== -->

  <!-- ===== FUNZIONE NON ABILITATA =====
       Nessun dealer nella configurazione dell'utente: al posto delle sezioni
       operative viene mostrato solo questo avviso. -->
  <div id="not-enabled-section" class="card warning-card mb-4" *ngIf="!hasDealerCodes">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-exclamation-triangle header-icon"></i>
          <h3>Funzione non abilitata</h3>
        </div>
      </div>
    </div>
    <div class="card-body">
      <p class="warning-card-text mb-0">
        Non sei abilitato a questa funzione: nella tua configurazione non risulta
        associato alcun <strong>codice dealer</strong>.
      </p>
      <p class="warning-card-hint mb-0">
        Contatta l'amministratore per farti assegnare le aziende di competenza.
      </p>
    </div>
  </div>

  <ng-container *ngIf="hasDealerCodes">

  <!-- ===== SECTION 2: RETURN REQUEST FORM ===== -->
  <div id="form-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-undo-alt header-icon"></i>
          <h3>Nuova richiesta di reso</h3>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="toggleFormCollapse()"
                [title]="isFormCollapsed ? 'Espandi' : 'Comprimi'">
          <i class="fas" [ngClass]="isFormCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="!isFormCollapsed">
        <div class="alert alert-warning d-flex align-items-center mb-0" *ngIf="!selectedCompanyCode">
          <i class="fas fa-exclamation-triangle me-2 fa-lg"></i>
          <div>
            <strong>Seleziona un'azienda per continuare.</strong><br>
            <small>Il form di richiesta reso sarà disponibile dopo aver scelto l'azienda dalla sezione "Aziende rappresentate".</small>
          </div>
        </div>

        <ng-container *ngIf="selectedCompanyCode">
        <!-- Avviso configurazione dealer mancante -->
        <div *ngIf="!selectedDealerHasConfig" class="alert alert-danger d-flex align-items-center mb-0">
          <i class="fas fa-exclamation-circle me-2 fa-lg"></i>
          <div>
            <strong>Settaggio incompleto.</strong><br>
            <small>Il dealer selezionato non ha una configurazione di reso valida. Contatta l'amministratore per completare il setup prima di procedere.</small>
          </div>
        </div>

        <ng-container *ngIf="selectedDealerHasConfig">

        <form id="form-required-fields" [formGroup]="returnForm" (ngSubmit)="onSubmit()">


          <!-- ===== Campi generali (a livello richiesta) - SOLO in modalità 'generate' ===== -->
          <ng-container *ngIf="formMode === 'generate'">
          <!-- Numero resi: quante entità pallet creare con questa richiesta (max 99). Prima riga, da solo. -->
          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label">Numero resi <span>*</span></label>
              <div class="input-group quantity-input-group">
                <button type="button" class="btn btn-outline-secondary"
                        (click)="changePalletQuantity(-1)"
                        [disabled]="palletQuantity <= 1"
                        title="Riduci il numero di resi">
                  <i class="fas fa-minus"></i>
                </button>
                <input type="number"
                       class="form-control text-center"
                       name="palletQuantity"
                       [(ngModel)]="palletQuantity"
                       [ngModelOptions]="{ standalone: true }"
                       [class.is-invalid]="!isPalletQuantityValid()"
                       min="1"
                       [max]="maxPalletQuantity"
                       step="1" />
                <button type="button" class="btn btn-outline-secondary"
                        (click)="changePalletQuantity(1)"
                        [disabled]="palletQuantity >= maxPalletQuantity"
                        title="Aumenta il numero di resi">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
              <div class="text-danger small mt-1" *ngIf="!isPalletQuantityValid()">
                Inserisci un numero tra 1 e {{ maxPalletQuantity }}
              </div>
              <small class="text-muted">Resi da creare (max {{ maxPalletQuantity }})</small>
            </div>
          </div>

          <div class="row">
            <div *ngFor="let field of generalFields; trackBy: trackByFormField" [ngClass]="field.colClass || 'col-md-4 mb-3'">
              <label class="form-label">
                {{ field.label }}<span *ngIf="field.required"> *</span>
              </label>

              <div class="position-relative">
                <ng-container [ngSwitch]="field.type">
                  <select *ngSwitchCase="'select'"
                          class="form-select"
                      [class.system-managed-field]="isSystemManagedField(field)"
                      [attr.disabled]="isSystemManagedField(field) ? '' : null"
                          [class.ps-5]="!!field.icon"
                          [class.is-invalid]="isFieldInvalid(field.name)"
                          [formControlName]="field.name">
                    <!-- Con una sola azienda l'opzione vuota è omessa: la selezione non è annullabile -->
                    <option value="" *ngIf="!isCompanySelectLocked(field)">{{ field.placeholder || 'Seleziona' }}</option>
                    <option *ngFor="let option of getFieldOptions(field)" [value]="option.code"
                            [title]="option.name">
                      {{ field.optionsSource === 'companies' ? truncateCompanyName(option.name) : option.name }}
                    </option>
                  </select>

                  <textarea *ngSwitchCase="'textarea'"
                            class="form-control"
                            rows="2"
                            [class.system-managed-field]="isSystemManagedField(field)"
                            [readonly]="isSystemManagedField(field)"
                            [attr.disabled]="isSystemManagedField(field) ? '' : null"
                            [class.ps-5]="!!field.icon"
                            [class.is-invalid]="isFieldInvalid(field.name)"
                            [formControlName]="field.name"
                            [placeholder]="field.placeholder || ''"></textarea>

                  <input *ngSwitchDefault
                         class="form-control"
                         [type]="field.type"
                        [class.system-managed-field]="isSystemManagedField(field)"
                        [readonly]="isSystemManagedField(field)"
                        [attr.disabled]="isSystemManagedField(field) ? '' : null"
                         [class.ps-5]="!!field.icon"
                         [class.is-invalid]="isFieldInvalid(field.name)"
                         [formControlName]="field.name"
                         [attr.min]="field.min ?? null"
                         [attr.max]="field.max ?? null"
                         [attr.step]="getFieldStep(field)"
                         [attr.maxlength]="field.maxLength ?? null"
                         (blur)="roundFieldDecimals(field)"
                         [placeholder]="field.placeholder || ''" />
                </ng-container>

                <i *ngIf="field.icon"
                   [class]="field.icon + ' position-absolute top-50 start-0 translate-middle-y ms-3 text-muted'"
                   style="pointer-events: none;"></i>
              </div>

              <div class="invalid-feedback" *ngIf="field.required || field.min !== undefined || field.max !== undefined">
                {{ getFieldErrorText(field) }}
              </div>
              <small class="text-muted" *ngIf="isSystemManagedField(field)">
                Valore settato automatico
              </small>
            </div>
          </div>
          </ng-container>

          <!-- ===== Sezione Pallet (solo modalità 'insert') ===== -->
          <ng-container *ngIf="selectedCompanyCode && formMode === 'insert' && itemFields.length">
            <!-- Toolbar: counter + azioni (Reset / Aggiungi) -->
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="header-title">
                <i class="fas fa-pallet header-icon me-2"></i>
                <strong>Resi ({{ palletsArray.length }})</strong>
              </div>
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-outline-secondary btn-sm"
                        (click)="resetPallets()"
                        [disabled]="palletsArray.length <= 1"
                        title="Reset resi">
                  <i class="fas fa-undo me-1"></i> Reset
                </button>
                <button type="button" class="btn btn-primary btn-sm"
                        (click)="addPallet()"
                        [disabled]="isMaxPalletsReached()"
                        [title]="isMaxPalletsReached() ? 'Limite massimo raggiunto' : 'Aggiungi reso'">
                  <i class="fas fa-plus me-1"></i> Aggiungi reso
                </button>
              </div>
            </div>

            <div formArrayName="pallets">
              <div *ngFor="let palletCtrl of palletsArray.controls; let i = index; trackBy: trackByPalletIndex"
                   [formGroupName]="i"
                   class="card parcel-card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">
                    <i class="fas fa-pallet me-2"></i>
                    Reso {{ i + 1 }}
                  </h5>
                  <div class="d-flex gap-2">
                    <button type="button" class="btn btn-outline-secondary btn-sm"
                            (click)="toggleItemCollapsed(i)"
                            [title]="isItemCollapsed(i) ? 'Espandi' : 'Comprimi'">
                      <i class="fas" [ngClass]="isItemCollapsed(i) ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                    </button>
                    <button type="button" class="btn btn-outline-danger btn-sm"
                            (click)="removePallet(i)"
                            [disabled]="palletsArray.length === 1"
                            title="Rimuovi reso">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>

                <div class="card-body" *ngIf="!isItemCollapsed(i)">
                  <div class="row">
                    <div *ngFor="let field of itemFields; trackBy: trackByFormField"
                         [ngClass]="field.colClass || 'col-md-4 mb-3'">
                      <label class="form-label">
                        {{ field.label }}<span *ngIf="field.required"> *</span>
                      </label>
                      <div class="position-relative">
                        <ng-container [ngSwitch]="field.type">
                          <select *ngSwitchCase="'select'"
                                  class="form-select"
                                  [class.ps-5]="!!field.icon"
                                  [class.is-invalid]="isItemFieldInvalid(i, field.name)"
                                  [formControlName]="field.name">
                            <option value="">{{ field.placeholder || 'Seleziona' }}</option>
                            <option *ngFor="let option of getFieldOptions(field, i)" [value]="option.code">{{ option.name }}</option>
                          </select>
                          <textarea *ngSwitchCase="'textarea'"
                                    class="form-control"
                                    rows="2"
                                    [class.ps-5]="!!field.icon"
                                    [class.is-invalid]="isItemFieldInvalid(i, field.name)"
                                    [formControlName]="field.name"
                                    [placeholder]="field.placeholder || ''"></textarea>
                          <input *ngSwitchDefault
                                 class="form-control"
                                 [type]="field.type"
                                 [class.ps-5]="!!field.icon"
                                 [class.is-invalid]="isItemFieldInvalid(i, field.name)"
                                 [formControlName]="field.name"
                                 [attr.min]="field.min ?? null"
                                 [attr.max]="field.max ?? null"
                                 [attr.step]="getFieldStep(field)"
                                 [attr.maxlength]="field.maxLength ?? null"
                                 (blur)="roundFieldDecimals(field, i)"
                                 [placeholder]="field.placeholder || ''" />
                        </ng-container>
                        <i *ngIf="field.icon"
                           [class]="field.icon + ' position-absolute top-50 start-0 translate-middle-y ms-3 text-muted'"
                           style="pointer-events: none;"></i>
                      </div>
                      <div class="invalid-feedback" *ngIf="field.required || field.min !== undefined || field.max !== undefined">
                        {{ getFieldErrorText(field, i) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Avvisi sul limite massimo -->
            <div *ngIf="isApproachingMaxPallets()" class="alert alert-warning small mb-0">
              <i class="fas fa-exclamation-triangle me-1"></i>
              Ti stai avvicinando al limite massimo di {{ maxPalletQuantity }} resi.
            </div>
            <div *ngIf="isMaxPalletsReached()" class="alert alert-danger small mb-0 mt-2">
              <i class="fas fa-times-circle me-1"></i>
              Limite massimo di {{ maxPalletQuantity }} resi raggiunto.
            </div>
          </ng-container>

          <div class="mt-4 pt-3 border-top">
            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-outline-secondary" (click)="resetForm()">
                <i class="fas fa-eraser me-1"></i> Reset
              </button>
              <button id="form-submit-btn" type="submit" class="btn btn-primary"
                      [disabled]="!selectedCompanyCode || returnForm.invalid || (formMode === 'generate' && !isPalletQuantityValid())"
                      [title]="returnForm.invalid ? 'Compila correttamente tutti i campi obbligatori' : ''">
                <i class="fas" [ngClass]="formMode === 'generate' ? 'fa-undo-alt me-1' : 'fa-paper-plane me-1'"></i>
                {{ formMode === 'generate' ? 'Genera reso' : 'Invia richiesta' }}
              </button>
            </div>
          </div>
        </form>
        </ng-container>
        </ng-container>
      </div>
  </div>

  <!-- ===== SECTION 3: FILTRI E AZIONI ===== -->
  <div id="filters-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-filter header-icon"></i>
          <h3>Filtri e Azioni</h3>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="toggleFiltersCollapsed()"
                [title]="isFiltersCollapsed ? 'Espandi' : 'Comprimi'">
          <i class="fas" [ngClass]="isFiltersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="!isFiltersCollapsed">
      <!-- Riga unica: codice reso, codice bolla, data da, data a -->
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Codice Reso</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-pallet filter-icon"></i>
            <input type="text" class="filter-input"
                   maxlength="99"
                   [(ngModel)]="filterPalletCode" (keyup.enter)="searchRequests()"
                   placeholder="Cerca per codice reso...">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codice Bolla</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-barcode filter-icon"></i>
            <input type="text" class="filter-input"
                   maxlength="99"
                   [(ngModel)]="filterWaybillCode" (keyup.enter)="searchRequests()"
                   placeholder="Cerca per codice bolla...">
          </div>
        </div>

        <!-- Date: stesso stile e comportamento dei filtri data di shipment-management -->
        <div class="col-md-3">
          <label class="form-label">Data Da</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #filterDateFromInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedFilterDateFrom()"
                   (click)="openFilterDateFromPicker()"
                   (focus)="openFilterDateFromPicker()"
                   readonly
                   placeholder="Seleziona data da">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="decrementFilterDateFrom()" title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setFilterDateFromToday()" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="incrementFilterDateFrom()" title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearFilterDateFrom()" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data A</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #filterDateToInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedFilterDateTo()"
                   (click)="openFilterDateToPicker()"
                   (focus)="openFilterDateToPicker()"
                   readonly
                   placeholder="Seleziona data a">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="decrementFilterDateTo()" title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setFilterDateToToday()" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="incrementFilterDateTo()" title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearFilterDateTo()" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Azioni filtri -->
      <div class="mt-4 pt-3 border-top">
        <div class="d-flex justify-content-end align-items-center">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-outline-secondary btn-sm"
                    (click)="resetFilters()"
                    title="Azzera filtri">
              <i class="fas fa-undo me-1"></i> Azzera filtri
            </button>
            <button type="button" class="btn btn-primary btn-sm"
                    (click)="searchRequests()"
                    [disabled]="isRequestsLoading"
                    title="Ricerca">
              <i class="fas" [ngClass]="isRequestsLoading ? 'fa-spinner fa-spin me-1' : 'fa-search me-1'"></i>
              Ricerca
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== SECTION 4: EXISTING REQUESTS ===== -->
  <div id="requests-list" class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
        <!-- Title on the left -->
        <div class="d-flex align-items-center gap-3 flex-wrap">
          <div class="header-title">
            <i class="fas fa-list-alt header-icon"></i>
            <h3>Richieste di reso ({{ isRequestsLoading ? '...' : totalCount }})</h3>
          </div>
        </div>

        <!-- Controls on the right -->
        <div class="controls-container">
          <!-- Filtro azienda nascosto (rimuovere *ngIf="false" per riattivarlo):
               senza selezione la tabella mostra i resi di tutte le aziende dell'utente -->
          <div class="btn-group btn-group-sm" role="group" aria-label="Filtro azienda" *ngIf="false">
            <select class="form-select form-select-sm company-select"
                    [(ngModel)]="filterByCompany" (change)="onCompanyFilterChange()"
                    title="Filtra per azienda">
              <option value="">Tutte le aziende</option>
              <option *ngFor="let c of companies" [value]="c.code" [title]="c.name">{{ truncateCompanyName(c.name) }}</option>
            </select>
          </div>

          <div class="btn-group btn-group-sm pagination-selector" role="group" aria-label="Elementi per pagina">
            <button type="button" class="btn"
                    *ngFor="let size of pageSizeOptions"
                    [ngClass]="itemsPerPage === size ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(size)"
                    [title]="size + ' elementi per pagina'">
              {{ size }}
            </button>
          </div>

          <div class="counter-display">
            <span class="badge bg-light text-muted">
              <i class="fas fa-list-alt me-1"></i>
              {{ isRequestsLoading ? '...' : totalCount }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body table-section-body">

      <div *ngIf="isRequestsLoading" class="d-flex flex-column align-items-center justify-content-center py-5">
        <div class="spinner-border text-primary mb-3" role="status" aria-label="Caricamento richieste di reso"></div>
        <div class="text-muted">Caricamento richieste di reso...</div>
      </div>

      <ng-container *ngIf="!isRequestsLoading">

      <!-- Table -->
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="table-light">
            <tr>
              <th style="width: 60px;">#</th>
              <th>Azienda</th>
              <th>Codice Reso</th>
              <th class="d-none d-md-table-cell">Bolla</th>
              <th class="d-none d-sm-table-cell">Data</th>
              <th class="d-none d-lg-table-cell">Tipo reso</th>
              <th class="d-none d-lg-table-cell">Peso</th>
              <th class="d-none d-lg-table-cell">Volume</th>
              <th>Stato</th>
              <th class="d-none d-xl-table-cell">Note</th>
              <th class="text-center">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of filteredRequests; let i = index">
              <td class="text-muted">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
              <td>
                <div class="fw-medium" [title]="r.dealerName">{{ truncateCompanyName(r.dealerName) }}</div>
                <small class="text-muted">{{ r.palletDealerCode }}</small>
              </td>
              <td class="fw-medium">
                <span>{{ r.palletCode }}</span>
                <i *ngIf="r.palletCode"
                   class="fas fa-copy copy-icon ms-1"
                   (click)="copyToClipboard(r.palletCode)"
                   title="Copia codice reso"></i>
              </td>
              <td class="d-none d-md-table-cell">
                <span>{{ getDisplayWaybillCode(r) || '-' }}</span>
                <i *ngIf="getDisplayWaybillCode(r)"
                   class="fas fa-copy copy-icon ms-1"
                   (click)="copyToClipboard(getDisplayWaybillCode(r))"
                   title="Copia codice bolla"></i>
              </td>
              <td class="d-none d-sm-table-cell">
                <span *ngIf="r.palletDate; else noDate">{{ r.palletDate | date:'dd/MM/yy HH:mm' }}</span>
                <ng-template #noDate><span class="text-muted">-</span></ng-template>
              </td>
              <td class="d-none d-lg-table-cell">
                <span *ngIf="r.palletDeliveryType; else unassigned">{{ r.palletDeliveryType }}</span>
                <ng-template #unassigned><span class="text-muted">Da Assegnare</span></ng-template>
              </td>
              <td class="d-none d-lg-table-cell">
                <span *ngIf="r.palletWeight != null; else noWeight">{{ r.palletWeight | number:'1.0-3' }} kg</span>
                <ng-template #noWeight><span class="text-muted">-</span></ng-template>
              </td>
              <td class="d-none d-lg-table-cell">
                <span *ngIf="r.palletVolume != null; else noVolume">{{ r.palletVolume | number:'1.0-4' }} m³</span>
                <ng-template #noVolume><span class="text-muted">-</span></ng-template>
              </td>
              <td>
                <span class="rr-badge" [ngClass]="getStatusBadgeClass(r.palletStatus)">
                  {{ getStatusLabel(r.palletStatus) }}
                </span>
              </td>
              <td class="d-none d-xl-table-cell">
                <small>{{ r.notes || '-' }}</small>
              </td>
              <td class="text-center">
                <button class="btn btn-sm btn-primary me-1" (click)="openPrintPopup(r)"
                        title="Stampa label / bolla">
                  <i class="fas fa-print"></i>
                </button>
                <button class="btn btn-sm btn-outline-danger" (click)="deleteRequest(r.id)"
                        [disabled]="!canDeleteRequest(r)"
                        [title]="canDeleteRequest(r) ? 'Elimina' : 'Eliminabile solo il giorno della bolla'">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="filteredRequests.length === 0">
              <td colspan="11" class="text-center text-muted py-4">
                <i class="fas fa-inbox fa-2x d-block mb-2"></i>
                Nessuna richiesta trovata
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div id="requests-pagination" class="pagination-container" *ngIf="totalCount > 0">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onPageChange(currentPage - 1)"
                  [disabled]="currentPage === 1" aria-label="Precedente" title="Precedente">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <button *ngFor="let page of getPageNumbers(); trackBy: trackByPageNumber"
                    class="pagination-number"
                    [class.active]="page === currentPage"
                    (click)="onPageChange(page)"
                    [attr.aria-label]="'Pagina ' + page"
                    [title]="'Vai alla pagina ' + page">
              {{ page }}
            </button>
          </div>

          <span class="pagination-info">
            {{ ((currentPage - 1) * itemsPerPage) + 1 }} - {{ Math.min(currentPage * itemsPerPage, totalCount) }} di {{ totalCount }}
          </span>

          <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
                  [disabled]="currentPage === getTotalPages()" aria-label="Successivo" title="Successivo">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      </ng-container>
    </div>
  </div>

  </ng-container>

</div>

<!-- Tour Guide Component -->
<app-tour-guide></app-tour-guide>

<!-- Return Settings Popup (solo ADMIN) -->
<app-return-settings-popup
  [visible]="isReturnSettingsPopupVisible"
  (closed)="closeReturnSettingsPopup()">
</app-return-settings-popup>

<!-- Return Request Print Popup (stampa label / bolla) -->
<app-return-request-print-popup
  [visible]="isPrintPopupVisible"
  [request]="printPopupRequest"
  [relatedPallets]="printPopupPallets"
  [dealer]="printPopupDealer"
  (closed)="closePrintPopup()">
</app-return-request-print-popup>

<!-- Return Request Summary Popup (riepilogo resi creati + stampa multipla) -->
<app-return-request-summary-popup
  [visible]="isSummaryPopupVisible"
  [pallets]="summaryPopupPallets"
  [dealer]="summaryPopupDealer"
  (closed)="closeSummaryPopup()">
</app-return-request-summary-popup>
